import G from "../images/hooshyarDam.png";
import I from "../images/looo.svg";
import H from "../images/lo.svg";
import Y from "../images/loo.svg";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { loginSuccessA } from "../redux/slices/superAdminSlice";
import Cookies from "js-cookie";
import apiService from "../api/ApiService";
import { useForm } from "react-hook-form";
import { addTimeDiff } from "../redux/slices/timeSlice";
import A from '../images/3.png'
import moment from "moment";
import {
  ArrowBack,
  ArrowForward,
  Key,
  MobileFriendly,
  Person,
  Repeat,
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { loginSuccess } from "../redux/slices/adminSlice";

const LoginPage = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [time, setTime] = useState("120");
  const [user, setUser] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const Login = async (data) => {
    try {
      setIsLoading(true);
      const res = await apiService.login(JSON.stringify(data));
      dispatch(loginSuccessA({id:res.data.userId,farmName:res.data?.farmName}))
      dispatch(loginSuccess({id:res.data.userId,farmName:res.data?.farmName}))
      dispatch(addTimeDiff(moment().format()
      ))
      let exp = res.data.expiresIn;
      let expiryDate = new Date();
      expiryDate.setSeconds(expiryDate.getSeconds() + 7200);
      document.cookie = `AuthToken=${res.data.token}; expires=${expiryDate}`;
      Cookies.set("exp", +expiryDate);
      if (Cookies.get("AuthToken") !== undefined) {
        navigate("/Dashboard");
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error)

    }
  };
  const forgetPass = async () => {
    if (user) {
      const res = await apiService.getOtpForgetPass(user);
      setMode("code");
      toast.success("کد تایید ارسال شد");
    }
  };
  const sendCode = async (data) => {
    const { newPass, otpCode } = data;
    const data1 = { newPassword: newPass, otpCode: otpCode, username: user };
    const res = await apiService.verifyOtpForgetPassword(data1);
    setMode("login");
  };
  const resendCode = async () => {
    if (time === 0) {
      setTime(120);
      const res = await apiService.getOtpForgetPass(user);
      toast.success("کد تایید جدید ارسال شد");
    }
  };

  useEffect(() => {
    if (mode === "code") {
      const intervalId = setInterval(() => {
        setTime((time) => {
          if (time <= 0) {
            clearInterval(intervalId);
            return 0;
          }
          return time - 1;
        });
      }, 1000);

      return () => clearInterval(intervalId);
    }
  }, [mode, time]);

  return (
    <div className="wholePage">
      <div className="ConSliderForm">
        <div className="sliderCon">
          <section className="slider">
            <div className="slides">
              <div className="item  active" id="slide1">
                <img src={I} alt="" />
                <span>پیشرفته ترین سیستم پایش گله</span>
                <div>
                  با بهره گیری از محصول شرکت هوشمند ارتباط شریف به نام هوشیار
                  دام، شما دامدار محترم و دامپزشک تان دسترسی بیست و چهار ساعته
                  به عملکرد و سلامت هر دام خواهید داشت. گردبند هوشمند هوشیار
                  دام، فعالیت­های هر دام را بررسی کرده و سلامت دام را به منظور
                  تشخیص و بهبود بیماری دام، برای رسیدن به بیشترین میزان تولید
                  شیر و افزایش زاد و ولد پایش می ­کند.
                </div>
              </div>
              <div className="item " id="slide2">
                <img src={H} alt="" />
                <span> راه حل هوشمندانه برای مدیریت دامداری</span>
                <div>
                  گجت هوشمند علائم رفتاری دام را با دقت بالا تشخیص می­ دهد. با
                  تشخیص علائم رفتاری، فعالیت دام در بازه ­های زمانی مختلف مورد
                  پردازش قرار گرفته و هوشیار دام اطلاعات مربوط به سلامت دام را
                  به دامدار نشان می­ دهد. در سیستم پایش گله­ ی هوشیار دام تغییر
                  رفتار ناگهانی سریعاً اطلاع رسانی می شود.
                </div>
              </div>
              <div className="item " id="slide3">
                <img src={Y} alt="" />
                <span>نظارت بر علائم رفتاری دام</span>
                <div>
                  وضعیت سلامت هر دام نقش مهمی در میزان بهره وری در گله دارد.
                  برای مدیریت صحیح گله و رسیدن به بهره وری حداکثری لازم است هر
                  دام تحت نظارت پیوسته و دقیق قرار گیرد. از طرفی نیروی کار موجود
                  در دامداری با توجه به مشغله زیاد قادر به نظارت دقیق و پیوسته
                  بر دام­ها نخواهد بود.
                </div>
              </div>
            </div>
          </section>
        </div>
        <div className="loginForm">
          <img className="imgLogo" src={G} />
          {mode === "login" && (
            <form onSubmit={handleSubmit(Login)}>
              <div className="inputContainerSS">
                <input
                  autoComplete="off"
                  type="text"
                  className="inputSS"
                  placeholder="a"
                  {...register("username", { required: "این مقدار ضروری است" })}
                />
                <label for="" className={"labelSS"}>
                  <Person fontSize="small" />
                  نام کاربری
                </label>
                {errors.username && (
                  <span className="errMsg">این مقدار ضروری است</span>
                )}
              </div>

              <div className="inputContainerSS">
                <input
                  autoComplete="off"
                  type="password"
                  className="inputSS"
                  placeholder="a"
                  {...register("password", { required: "این مقدار ضروری است" })}
                />
                <label for="" className={"labelSS"}>
                  <Key fontSize="small" />
                  رمز عبور
                </label>
                {errors?.password && (
                  <span className="errMsg">این مقدار ضروری است</span>
                )}
              </div>
              <button
                disabled={isLoading}
                className="EditMOdalBtnForm"
                type="submit"
                style={{ marginTop: "30px" }}
              >
                {isLoading ? <img className="singleLoading" src={A} style={{width:"30px",height:"auto"}}/> : <span>ورود</span>}
              </button>
            </form>
          )}
          {mode === "phoneNumber" && (
            <form onSubmit={handleSubmit(forgetPass)}>
              <div className="inputContainerSS">
                <input
                  autoComplete="off"
                  type="text"
                  className="inputSS"
                  placeholder="a"
                  value={user}
                  onChange={(e) => setUser(e.target.value)}
                />
                <label for="" className={"labelSS"}>
                  <MobileFriendly fontSize="small" /> حساب کاربری
                </label>
                {!user && (
                  <span className="errMsg">حساب کاربری خود را وارد کنید</span>
                )}
              </div>

              <button
                className="EditMOdalBtnForm"
                type="submit"
                style={{ marginTop: "30px" }}
              >
                دریافت کد تایید
              </button>
            </form>
          )}
          {mode === "code" && (
            <form onSubmit={handleSubmit(sendCode)}>
              <div className="inputContainerSS">
                <input
                  autoComplete="off"
                  type="number"
                  className="inputSS"
                  placeholder="a"
                  {...register("otpCode", { required: "این مقدار ضروری است" })}
                />
                <label for="" className={"labelSS"}>
                  <MobileFriendly fontSize="small" /> کد تایید
                </label>
                {errors.otpCode && (
                  <span className="errMsg">{errors?.otpCode?.message}</span>
                )}
              </div>
              <div className="inputContainerSS">
                <input
                  autoComplete="off"
                  type="password"
                  className="inputSS"
                  placeholder="a"
                  {...register("newPass", { required: "این مقدار ضروری است" })}
                />
                <label for="" className={"labelSS"}>
                  <Key fontSize="small" /> رمز عبور جدید
                </label>
                {errors.newPass && (
                  <span className="errMsg">{errors?.newPass?.message}</span>
                )}
              </div>
              <div className="inputContainerSS">
                <input
                  autoComplete="off"
                  type="password"
                  className="inputSS"
                  placeholder="a"
                  {...register("repeatPass", {
                    required: "این مقدار ضروری است",
                  })}
                />
                <label for="" className={"labelSS"}>
                  <Repeat fontSize="small" /> تکرار رمز عبور
                </label>
                {errors.repeatPass && (
                  <span className="errMsg">{errors?.repeatPass?.message}</span>
                )}
              </div>

              <button
                className="EditMOdalBtnForm"
                type="submit"
                style={{ marginTop: "20px" }}
              >
                تایید
              </button>
              <div
                className="forgetPassBtnForm"
                style={{ cursor: "auto", direction: "ltr" }}
              >
                {time > 0 ? (
                  `${Math.floor(time / 60)}:${`${time % 60}`.padStart(
                    2,
                    "0"
                  )} اعتبار کد تا`
                ) : (
                  <span className="forgetPassBtnForm" onClick={resendCode}>
                    ارسال مجدد کد تایید
                  </span>
                )}
              </div>
            </form>
          )}
          {mode === "login" && (
            <div
              onClick={() => {
                setMode("phoneNumber");
              }}
              className="forgetPassBtnForm"
            >
              رمز عبور خود را فراموش کرده اید؟
            </div>
          )}
          {mode === "phoneNumber" && (
            <div
              onClick={() => {
                setMode("login");
              }}
              className="forgetPassBtnForm backtoLogin"
            >
              <ArrowForward color="success" fontSize="small" /> بازگشت به ورود
            </div>
          )}
          <div className=" loginformLinks">
            <div className="forgetPassBtnForm">
              <a
                target="_blank"
                href="http://sscomm.ir/%d8%af%d8%b1%d8%ae%d9%88%d8%a7%d8%b3%d8%aa-%d8%ae%d8%af%d9%85%d8%a7%d8%aa/"
              >
                حساب کاربری ندارید؟
              </a>
            </div>
            <div className="forgetPassBtnForm">
              <a target="_blank" href="http://sscomm.ir/">
                آشنایی با هوشیار دام
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default LoginPage;
